import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Node, Slice, Fragment } from '@tiptap/pm/model';
import constants from '@/utilities/constants';
import { InlineMediaNode } from '@superthread-com/extension-inline-media/src/index';

const ignoredNodes = [constants.stImage, InlineMediaNode.Generic];
const filterNodes = (fragment: Fragment) => {
  const nodes: Node[] = [];
  fragment.forEach((child) => {
    if (!ignoredNodes.includes(child.type.name)) {
      nodes.push(child);
    }
  });
  return Fragment.fromArray(nodes);
};
const FilterFiles = Extension.create({
  name: 'filterFiles',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('filterFiles'),
        props: {
          transformPasted(slice) {
            return new Slice(filterNodes(slice.content), slice.openStart, slice.openEnd);
          },
        },
      }),
    ];
  },
});

export default FilterFiles;
